import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const { t } = useLanguage();
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <div className="privacy-header">
          <h1>{t('policy.privacy.title')}</h1>
          <p className="subtitle">{t('policy.privacy.subtitle')}</p>
        </div>

        <div className="privacy-content">
          <p className="privacy-intro">
            {t('policy.privacy.intro')}
          </p>

          <div className="privacy-section">
            <h2>{t('policy.privacy.s1Title')}</h2>
            <p>
              {t('policy.privacy.s1Text')}
            </p>
          </div>

          <div className="privacy-section">
            <h2>{t('policy.privacy.s2Title')}</h2>
            <p>
              {t('policy.privacy.s2Text')}
            </p>
            <p>{t('policy.privacy.s2Guarantee')}</p>
            <ul className="privacy-list">
              <li>{t('policy.privacy.s2Li1')}</li>
              <li>{t('policy.privacy.s2Li2')}</li>
              <li>{t('policy.privacy.s2Li3')}</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>{t('policy.privacy.s3Title')}</h2>
            <p>
              {t('policy.privacy.s3Text')}
            </p>
          </div>

          <div className="privacy-section">
            <h2>{t('policy.privacy.s4Title')}</h2>
            <p>
              {t('policy.privacy.s4Text')}
            </p>
          </div>

          <Link to="/" className="back-link">
            {t('policy.backLink')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
